import React from 'react';
import type { Feature } from '../../types/feature.types';
import Card from '@components/ui/Card';

interface FeatureCardProps {
  feature: Feature;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ feature }) => {
  return (
    <Card className="p-6">
      <div className="flex items-start">
        <div className={`${feature.iconBgColor} rounded-full p-2 mr-3`}>
          {feature.icon}
        </div>
        <div>
          <h3
            className="font-semibold text-gray-900 mb-2"
            style={{ fontFamily: "'Poppins', sans-serif" }}
            dangerouslySetInnerHTML={{ __html: feature.title }}
          />
          <p
            className="text-sm text-gray-600"
            dangerouslySetInnerHTML={{ __html: feature.description }}
          />
        </div>
      </div>
    </Card>
  );
};

export default FeatureCard;